import { render, staticRenderFns } from "./achievementShow.vue?vue&type=template&id=45f2afb7&scoped=true&"
import script from "./achievementShow.vue?vue&type=script&lang=js&"
export * from "./achievementShow.vue?vue&type=script&lang=js&"
import style0 from "./achievementShow.vue?vue&type=style&index=0&id=45f2afb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2afb7",
  null
  
)

export default component.exports